<section one-column>
  <div>
    <h3>{{ 'settlement.brand' | translate }}</h3>
	<p>{{ brand?.name }} <icon [attr.brand]="brand?.shortName" type="logo" small /></p>
  </div>
  <div>
    <h3>{{ 'settlement.reason-for-settlement' | translate }}</h3>
    <p>{{ settlement.reason?.name ?? ('reason.unknown' | translate) }}</p>
  </div>
  @if (settlement.comment?.length ?? 0 > 0) {
    <div>
      <h3>{{ 'settlement.comment-for-settlement' | translate }}</h3>
      <p>{{ settlement.comment }}</p>
    </div>
  }
</section>

<h2>{{ 'settlement.product-plans-in-settlement' | translate }}</h2>
@if (loading) {
  <skeletons [defaultSkeletons]="5" />
}
@if (!loading) {
  <settlement-product-plans [settlement]="settlement" [plansAmount]="plansAmount" [showIncludeVat]="true" [selectable]="false" [clickable]="false" />
}

<section three-columns>
  @if (loading) {
    <skeletons [defaultSkeletons]="2" />
  }
  @if (!loading) {
    <summary [label]="'settlement.total-amount-closed' | translate">{{addVat(totalClosedAmount) | currency}}</summary>
  }
  @if (!loading) {
    <summary [label]="'settlement.total-amount-open' | translate">{{addVat(totalOpenAmount) | currency}}</summary>
  }
  @if (!loading) {
    <summary [label]="'settlement.total-amount-agreed' | translate">{{addVat(settlementSum) | currency}}</summary>
  }
</section>
<spacer />

<h2>{{ 'settlement.installments' | translate }}</h2>
<list-view [selectable]="false">
  <header [sortColumn]="false" defaultSort="ascending">{{ 'settlement.installment-column-header.number' | translate }}</header>
  <header [sortColumn]="false">{{ 'settlement.installment-column-header.due-date' | translate }}</header>
  <header [sortColumn]="false"  align-right>{{ 'settlement.installment-column-header.amount-incl-vat' | translate }}</header>
  <row *listData="let installment from settlement.settlementInstallments" [clickable]="false">
    <column [sortValue]="installment.number">{{ settlement.installments == 1 ? ('installment-number'  | translate) : ('installment-number-of-total' | translate: { number: installment.number, total: settlement.installments }) }}</column>
    <column>{{ installment.dueDate | customDate: 'shortDate' }}</column>
    <column align-right>{{ installment.amount | currency }}</column>
  </row>
</list-view>
